import { createAction } from 'redux-actions';

export const SET_FILTER_PARAMS = 'MAP.SET_FILTER_PARAMS';
export const setFilterParams = createAction(SET_FILTER_PARAMS);

export const SET_SINGLE_FILTER_PARAM = 'MAP.SET_SINGLE_FILTER_PARAM';
export const setSingleFilterParam = createAction(SET_SINGLE_FILTER_PARAM);

export const SET_SHAPEFILE = 'MAP.SET_SHAPEFILE';
export const setShapeFile = createAction(SET_SHAPEFILE);

export const SET_MAP_READY = 'MAP.SET_MAP_READY';
export const setMapReady = createAction(SET_MAP_READY);

export const SET_ZONING_FILES = 'MAP.SET_ZONING_FILES';
export const setZoningFiles = createAction(SET_ZONING_FILES);

export const SET_FEATURED_DECKARDID = 'MAP.SET_FEATURED_DECKARDID';
export const setFeaturedDeckardId = createAction(SET_FEATURED_DECKARDID);
